import React from "react";
import { Box, Typography,styled, } from "@mui/material";

const EldtBanner = styled(Box)(({ theme }) => ({
    backgroundImage:
      "url(https://cdlschool.com/hubfs/ELDT%20Banner%20%281%29.webp)",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: "100vw",
    height: "400px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    color: "white",
    textAlign: "center",
    padding: "20px",
    marginBottom: "50px",
    position: "relative",
    left: "50%",
    right: "50%",
    transform: "translateX(-50%)",
    boxSizing: "border-box",
  
    [theme.breakpoints.down("md")]: {
      height: "320px",
      padding: "15px",
    },
  
    [theme.breakpoints.down("sm")]: {
      height: "280px",
      padding: "10px",
    },
  }));
  
  const BannerHeading = styled(Typography)(({ theme }) => ({
    fontSize: "48px",
    fontWeight: 600,
    marginBottom: "25px",
    color: "white",
  
    [theme.breakpoints.down("md")]: {
      fontSize: "36px",
    },
  
    [theme.breakpoints.down("sm")]: {
      fontSize: "28px",
    },
  }));
  
  const BannerText = styled(Typography)(({ theme }) => ({
    fontSize: "20px",
    fontWeight: "bold",
    marginBottom: "20px",
    color: "#efc819",
    maxWidth: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  
    [theme.breakpoints.down("md")]: {
      fontSize: "16px",
      whiteSpace: "normal",
      overflow: "visible",
      textOverflow: "unset",
    },
  
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  }));

const Banner = () => {
  return (
    <EldtBanner>
      <BannerHeading variant="h1">
        Get your ELDT Theory Certification with The CDL Schools
      </BannerHeading>
      <BannerText>
        We offer FMCSA Registered self-guided and instructor led online ELDT
        Theory Certification programs for future truck drivers.
      </BannerText>
      <BannerText>
        Use the tool below to explore your training options.
      </BannerText>
    </EldtBanner>
  );
};

export default Banner;
